<template>
    <div v-if='!empty'>
        <div class='container'>
            <div class='row'>
                <div class='col-sm-12'>
                <h2>{{module.title}}</h2>
                <h3>{{module.subtitle}}</h3>
                <iframe class='youtubeViewer' v-if='module.videourl' :src="'https://www.youtube-nocookie.com/embed/' + videoId + '?cc_load_policy=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>

            <div class='row resourceContent'>
                <div class='col-sm-9' v-if='hasContent' v-html='module.content'>
                    
                </div>
                <div :class="{ 'col-sm-3': hasContent, 'col-sm-12': !hasContent }" >
                    <image-gallery :gallery='module.gallery' :carousel='false' direction='vertical'></image-gallery>

                    <transition-group v-if='module.resources.length > 0' name="list" tag='div' :class="{'resourceTilesVertical': hasContent, 'resourceTiles': !hasContent}">
                        <component :is='componentType(resource)' v-for='resource in module.resources' :key='resource.id' :resource='resource'></component>
                    </transition-group>
                </div>
            </div>

            <div class='row'>
                <div class='col-sm-12'>
                    <transition-group v-if='module.modules.length > 0' name="list" tag='div' class='resourceTiles'>
                        <module-tile v-for='module in module.modules' :key='module.slug' :module='module'></module-tile>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import util from '../../util'
import _ from 'lodash'
import ImageGallery from '../../components/ImageGallery'

import YouTubeTile from '../../components/YouTubeTile'
import PdfTile from '../../components/PdfTile'
import PageTile from '../../components/PageTile'
import ContentTile from '../../components/ContentTile'
import EmbedTile from '../../components/EmbedTile'
import EducationModuleTile from '../../components/EducationModuleTile'

let types = {
    'Page': 'page-tile',
    'PDF': 'pdf-tile',
    'YouTube': 'youtube-tile',
    'Content': 'content-tile',
    'Embed': 'embed-tile'
}

export default {
    props: ['slug'],
    data() {
        return {
            module: {}
        }
    },
    computed: {
        videoId() {
            return util.videoId(this.module.videourl);
        },
        empty() {
            return _.isEmpty(this.module);
        },
        hasContent() {
            return !_.isEmpty(this.module.content)
        }
    },
    methods: {
        refresh() {
            let query = JSON.stringify({ "id": this.slug });
            axios.get(`${this.$api}/education/modules?query=${query}`).then((response) => {
                this.module = response.data;
            });
        },
        componentType(resource) {
            return types[resource.type];
        },
    },
    created() {
        if (this.$route.params.module) {
            this.module = this.$route.params.module;
        }
        
        this.refresh();
    },
    watch: {
        '$route'() {
            this.refresh();
        }
    },
    components: {
        'page-tile': PageTile,
        'pdf-tile': PdfTile,
        'youtube-tile': YouTubeTile,
        'content-tile': ContentTile,
        'embed-tile': EmbedTile,
        'image-gallery': ImageGallery,
        'module-tile': EducationModuleTile
    }
}
</script>